module.exports = __webpack_public_path__ + "img/selfAdhesive1.c9d51c1e.jpg";